import { getKenkoSvg } from "../../../Assets/images/kenko";
import {
  PacmanFooterSushishop,
  PacmanHeaderSushishop,
  PacmanHeaderSushiArt,
  PacmanFooterSushiArt,
  Logo_sushiart_blanc,
  Logo_sushiart_champagne,
  Logo_sushiart_noir,
  Logo_sushishop_blanc,
  Logo_sushishop_champagne,
  Logo_sushishop_noir,
} from "../../../Assets/images/pacman";

export const logoSvgBase = {
  "pacman-footer-sushishop": PacmanFooterSushishop,
  "pacman-header-sushishop": PacmanHeaderSushishop,
  "pacman-header-sushiart": PacmanHeaderSushiArt,
  "pacman-footer-sushiart": PacmanFooterSushiArt,
  logo_sushiart_blanc: Logo_sushiart_blanc,
  logo_sushiart_champagne: Logo_sushiart_champagne,
  logo_sushiart_noir: Logo_sushiart_noir,
  logo_sushishop_blanc: Logo_sushishop_blanc,
  logo_sushishop_champagne: Logo_sushishop_champagne,
  logo_sushishop_noir: Logo_sushishop_noir,
  kenko: getKenkoSvg,
};
